import { IProduct } from '../../types/analytics';
import { IApplicationState } from '../../types/redux';

export const getProduct =
  (id: number) =>
  (state: IApplicationState): IProduct => {
    return state.analytics.productsById[id];
  };
